// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.access-notice {
  border: 1px solid #e2e5e8;
  background: #fff;
}
.access-notice .card-body {
  padding: 2.5rem 1.5rem;
}
.access-notice__inner {
  max-width: 32rem;
  margin: 0 auto;
  text-align: center;
}
.access-notice__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 3.5rem;
  height: 3.5rem;
  margin-bottom: 1.25rem;
  border-radius: 50%;
  background: var(--m-primary-subtle, #e6f7fa);
  color: var(--m-primary, #00a3bf);
}
.access-notice__icon svg {
  width: 1.5rem;
  height: 1.5rem;
}
.access-notice__title {
  margin: 0 0 0.75rem;
  font-size: 1.125rem;
  font-weight: 600;
  color: #212529;
  letter-spacing: -0.01em;
}
.access-notice__lead {
  margin: 0 0 1.25rem;
  font-size: 0.9375rem;
  line-height: 1.55;
  color: #6c757d;
}
.access-notice__panel {
  text-align: left;
  padding: 1rem 1.25rem;
  border-radius: 8px;
  background: #f8f9fa;
  border: 1px solid #e9ecef;
}
.access-notice__panel-title {
  margin: 0 0 0.5rem;
  font-size: 0.8125rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #495057;
}
.access-notice__steps {
  margin: 0;
  padding-left: 1.25rem;
  font-size: 0.875rem;
  line-height: 1.6;
  color: #495057;
}
.access-notice__steps li + li {
  margin-top: 0.35rem;
}
.access-notice__footer {
  margin: 1.25rem 0 0;
  font-size: 0.8125rem;
  color: #868e96;
}`, "",{"version":3,"sources":["webpack://./src/components/CustomUI/AccessNotice/style.scss"],"names":[],"mappings":"AAAA;EACE,yBAAA;EACA,gBAAA;AACF;AACE;EACE,sBAAA;AACJ;AAEE;EACE,gBAAA;EACA,cAAA;EACA,kBAAA;AAAJ;AAGE;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,cAAA;EACA,sBAAA;EACA,kBAAA;EACA,4CAAA;EACA,gCAAA;AADJ;AAGI;EACE,aAAA;EACA,cAAA;AADN;AAKE;EACE,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,uBAAA;AAHJ;AAME;EACE,mBAAA;EACA,oBAAA;EACA,iBAAA;EACA,cAAA;AAJJ;AAOE;EACE,gBAAA;EACA,qBAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;AALJ;AAQE;EACE,kBAAA;EACA,oBAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cAAA;AANJ;AASE;EACE,SAAA;EACA,qBAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;AAPJ;AASI;EACE,mBAAA;AAPN;AAWE;EACE,mBAAA;EACA,oBAAA;EACA,cAAA;AATJ","sourcesContent":[".access-notice {\n  border: 1px solid #e2e5e8;\n  background: #fff;\n\n  .card-body {\n    padding: 2.5rem 1.5rem;\n  }\n\n  &__inner {\n    max-width: 32rem;\n    margin: 0 auto;\n    text-align: center;\n  }\n\n  &__icon {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 3.5rem;\n    height: 3.5rem;\n    margin-bottom: 1.25rem;\n    border-radius: 50%;\n    background: var(--m-primary-subtle, #e6f7fa);\n    color: var(--m-primary, #00a3bf);\n\n    svg {\n      width: 1.5rem;\n      height: 1.5rem;\n    }\n  }\n\n  &__title {\n    margin: 0 0 0.75rem;\n    font-size: 1.125rem;\n    font-weight: 600;\n    color: #212529;\n    letter-spacing: -0.01em;\n  }\n\n  &__lead {\n    margin: 0 0 1.25rem;\n    font-size: 0.9375rem;\n    line-height: 1.55;\n    color: #6c757d;\n  }\n\n  &__panel {\n    text-align: left;\n    padding: 1rem 1.25rem;\n    border-radius: 8px;\n    background: #f8f9fa;\n    border: 1px solid #e9ecef;\n  }\n\n  &__panel-title {\n    margin: 0 0 0.5rem;\n    font-size: 0.8125rem;\n    font-weight: 600;\n    text-transform: uppercase;\n    letter-spacing: 0.04em;\n    color: #495057;\n  }\n\n  &__steps {\n    margin: 0;\n    padding-left: 1.25rem;\n    font-size: 0.875rem;\n    line-height: 1.6;\n    color: #495057;\n\n    li + li {\n      margin-top: 0.35rem;\n    }\n  }\n\n  &__footer {\n    margin: 1.25rem 0 0;\n    font-size: 0.8125rem;\n    color: #868e96;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
